<template>
    <!--届け先振り分け設定パーツ-->
    <div class="sh041" id="sh041" v-cloak>
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <div class="section-inner">
            <!--エラーメッセージ表示 -->
            <div class="errMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH041_PART"/>
            </div>
            <!-- カート情報 -->
            <div class="itemTitle">
                <h2>{{$t("sh041.labels.cartInfo")}}</h2>
            </div>
            <!-- 商品一覧 ここから  -->
            <div v-if="dataInit.cartInfoList && dataInit.cartInfoList.length>0" class="itemTable" id="cartInfo">
                <div class="itemHeader">
                    <div class="label divNo">
                        <!--No-->
                        <label class="no">{{$t('common.labels.no')}}</label>
                    </div>
                    <div class="label divItemNm">
                        <!-- 商品名 -->
                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                    </div>
                    <div class="label divPrice">
                        <!-- 単価  -->
                        <label class="unitPrice">{{$t('common.labels.unitPrice')}}</label>
                    </div>
                    <div class="label divQty">
                        <!-- カート数量 -->
                        <label class="quantity">{{$t('sh041.labels.cartQuantity')}}</label>
                    </div>
                    <div class="label divTax">
                        <!--振分済数-->
                        <label class="quantity">{{$t('sh041.labels.furiwakeQty')}}</label>
                    </div>
                </div>
                <div class="itemBody">
                    <div v-for="(product, index) in dataInit.cartInfoList" :key="index" class="itemList">
                        <!--No -->
                        <div class="label divNo" :aria-label="$t('common.labels.no')">
                            {{index + 1}}
                        </div>
                        <!--商品名 -->
                        <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                            <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.M_ITEM_CD}}">
                                {{common.stringNvl(product.WEB_ITEM_NM,'')}}
                            </router-link>
                            <div v-for="(item, idx) in dataInit.optionList" :key="idx">
                                <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                            </div>
                        </div>
                        <!--単価-->
                        <div class="label divPrice" :aria-label="$t('common.labels.unitPrice')">
                            <!-- 税込みの場合 -->
                            <span v-if="dataInit.tnkDspKbn == '1'">
                                {{common.formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}
                            </span>
                            <span v-else>
                                {{common.formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}
                            </span>
                        </div>
                        <!--カート数量 -->
                        <div class="label divQty" :aria-label="$t('common.labels.quantity')">
                            <span>{{product.QTY}}</span>
                        </div>
                        <!--振分済数-->
                        <div  class="label divQty" :aria-label="$t('sh041.labels.furiwakeQty')">
                            <span v-if = "product.BINSYU_KBN == '90' " >{{$t('sh041.labels.shopReceipt')}}</span>
                            <span v-else> {{furiwakeQty(product.M_ITEM_CD,product.SEQ)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 商品一覧 ここまで  -->

            <!-- お届け先ごとに指定してください -->
            <div class="itemTitle">
                <h2>{{$t("sh041.labels.tdkInfoSetting")}}</h2>
            </div>
            <!-- お届け先 ここから  -->
            <div v-if="reqModel.tdkInfoList" class="itemTable" id="tdkInfo">
                <div class="itemBody">
                    <div v-for="(tdk, index) in reqModel.tdkInfoList" :key="index" class="itemList">
                        <!--お届け先 -->
                        <div :id="'tdkInfo_'+index" class="label divTdkNm" :aria-label="$t('sh041.labels.tdkNm')">
                            <span >{{$t("sh041.labels.tdkNm")}}</span>
                            <div >
                                <dt >{{tdk.tdkNm1}} {{tdk.tdkNm2}} {{tdk.tdkNm3}} {{tdk.tdkTitle}}</dt>
                            </div>
                        </div>
                        <!--送主 -->
                        <div :id="'tdkOkuriScroll_'+index" class="label divCsmNm" :aria-label="$t('sh041.labels.csmNm')">
                            <span >{{$t("sh041.labels.csmNm")}}</span>
                            <div >
                                <dt v-if="tdk.okuriNushiCheckBox != 1">{{tdk.csmNm}} {{tdk.csmTitle}}</dt>
                                <label v-if="dataInit.csmInfoOption == 1" :for="'okuriNushiCheckBox_'+index" class="select_add">
                                <input type="checkbox" :id="'okuriNushiCheckBox_'+index" true-value="1" false-value="0" v-model="tdk.okuriNushiCheckBox" 
                                    class="sh041-inpCsmNm">
                                <!-- 別の送主を指定する -->
                                <b>{{$t("sh041.buttons.changeCsm")}}</b>
                            </label>
                            </div>
                        </div>

                        <!--送り主（BtoC） -->
                        <div class="sh041-body-okurinushi-area" id="hide_table_4" v-if="tdk.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1 && dataInit.siteFlg != 1">
                            <div class="sh041-body-subtitle">
                                <h4>送主情報</h4>
                                <!--送り主を一括反映-->
                                <button class="sh041-tdk-btn2" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setIkkatuOkuriInfo(index)">
                                    {{$t("sh041.buttons.okurihanei")}}
                                </button>
                            </div>
                            <table class="sh041-body-order-tbl-person" >
                                <tr>
                                    <th class="sh041-th-name required">
                                        <!-- お名前※ -->
                                        {{$t("sh030.labels.name")}}
                                    </th>
                                    <td>
                                        <div class="sh041-form-column left ">
                                            <input type="hidden" v-model="tdk.csmNo">
                                            <!-- 姓 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            </template>
                                            <template v-else>
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                        v-model="tdk.csmNm1" size="20"
                                                        maxlength="30" class="sh041-inp-csmNm1"/>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用する場合-->
                                            <template v-else>
                                                <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                        disabled
                                                        v-model="tdk.csmNm1" size="20" 
                                                        maxlength="30" class="sh041-inp-csmNm1"/>
                                            </template>
                                            <!-- 名2 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                    <input-check type="text" :id="'csmNm2_'+index" :name="'csmNm2_'+index"
                                                                v-model="tdk.csmNm2" size="20"
                                                                maxlength="30" class="sh041-inp-csmNm2"/>
                                                </template>
                                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                                <template v-else>
                                                    <input-check type="text" :id="'csmNm2_'+index" :name="'csmNm2_'+index"
                                                                disabled 
                                                                v-model="tdk.csmNm2" size="20"
                                                                maxlength="30" class="sh041-inp-csmNm2"/>
                                                </template>
                                            </template>
                                        </div>
                                        <!-- 送主を検索-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="searchOkuriNushiList(index)">{{$t("sh030.labels.okuriAddressee")}}</button>
                                        <!-- 注文者情報を反映-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setKokyakuInfo(index)">{{$t("sh041.buttons.setKokyaku")}}</button>
                                        <br />
                                        <div v-html="descriptionInfo[17]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- フリガナ -->
                                    <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.nameKana")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.nameKana")}}</th>
                                    <td>
                                        <div class="sh041-form-column">
                                            <!-- 姓 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            </template>
                                            <template v-else>
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                        v-model="tdk.csmKana1" size="20"
                                                        maxlength="30" class="sh041-inp-csmKana1"/>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用する場合-->
                                            <template v-else>
                                                <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                        disabled
                                                        v-model="tdk.csmKana1" size="20"
                                                        maxlength="30" class="sh041-inp-csmKana1"/>
                                            </template>
                                            <!-- 名 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                    <input-check type="text" :id="'csmKana2_'+index" :name="'csmKana2_'+index"
                                                            v-model="tdk.csmKana2" size="20"
                                                            maxlength="30" class="sh041-inp-csmKana2"/>
                                                </template>
                                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                                <template v-else>
                                                    <input-check type="text" :id="'csmKana2_'+index" :name="'csmKana2_'+index"
                                                            disabled 
                                                            v-model="tdk.csmKana2" size="20"
                                                            maxlength="30" class="sh041-inp-csmKana2"/>
                                                </template>
                                            </template>
                                            <br/>
                                        </div>
                                        <div v-html="descriptionInfo[18]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 郵便番号 -->
                                        {{$t("common.labels.postalCode")}}
                                    </th>
                                    <td ontouchstart="">
                                        <input-check type="text" :id="'csmZip_'+index" :name="'csmZip_'+index" 
                                            v-model="tdk.csmZip" size="13" maxlength="8" class="zip sh041-inp-csmZip"/>
                                        <!-- 住所自動入力 -->
                                        <button class="sh041-btn-csmZip" @click="setAddr(index)"> {{$t("common.labels.addressSearch")}}</button>
                                        <div v-html="descriptionInfo[19]"></div>
                                    </td>
                                </tr>
                                <!-- 都道府県 -->
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <tr>
                                        <th class="required">
                                            <!-- 都道府県 -->
                                            {{$t("sh030.labels.prefectures")}}
                                        </th>
                                        <td>
                                            <select v-model="tdk.csmKen" :id="'csmKen_'+index" class="sh041-sel-csmKen">
                                                <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmKen">{{ken.VALUE}}</option>
                                            </select>
                                            <br>
                                            <div v-html="descriptionInfo[20]"></div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <input type="hidden" :id="'csmKen_'+index" v-model="tdk.csmKen" />
                                </template>
                                <tr>
                                    <!-- 住所（市区郡町村） -->
                                    <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                                    <td>
                                        <input-check :id="'csmAddr1_'+index" type="text" :name="'csmAddr1_'+index" size="50" 
                                            class="sh041-inp-csmAddr1"
                                            v-model="tdk.csmAddr1" maxlength="30"/>
                                        <br/>
                                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                                            <div v-html="descriptionInfo[21]"></div>
                                        </template>
                                        <template v-else>
                                            <div v-html="descriptionInfo[22]"></div>
                                        </template>
                                    </td>
                                </tr>
                                <!-- 住所（番地以下） -->
                                <tr v-if="dataInit.addr2Flg == 1">
                                    <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                                    <td>
                                        <input :id="'csmAddr2_'+index" type="text" :name="'csmAddr2_'+index" 
                                            class="sh041-inp-csmAddr2"
                                            size="50" v-model="tdk.csmAddr2" maxlength="30"/><br/>
                                        <div v-html="descriptionInfo[23]"></div>
                                    </td>
                                </tr>
                                <!-- 住所（マンション名・会社名等） -->
                                <tr v-if="dataInit.addr3Flg == 1">
                                    <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                                    <td>
                                        <input :id="'csmAddr3_'+index" type="text" :name="'csmAddr3_'+index" size="50"
                                            class="sh041-inp-csmAddr3"
                                            v-model="tdk.csmAddr3" maxLength="30"/><br/>
                                        <div v-html="descriptionInfo[24]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 電話番号※ -->
                                        {{$t("sh030.labels.phoneNumber※")}}
                                    </th>
                                    <td>
                                        <input-check type="text" :id="'csmTel_'+index" :name="'csmTel_'+index" 
                                            class="sh041-inp-csmTel"
                                            v-model="tdk.csmTel" size="20" maxlength="14"/>
                                        <br>
                                        <div v-html="descriptionInfo[25]"></div>
                                    </td>
                                </tr>
                            </table>
                            <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                            <p  class="mb64 input-p-desc-css">
                                <span v-html="descriptionInfo[31]"></span>
                            </p>
                        </div>
                        <!--送り主（BtoB） -->
                        <div class="sh041-body-okurinushi-area" id="hide_table_4" v-if="tdk.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1  && dataInit.siteFlg == 1">
                            <div class="sh041-body-subtitle"><h4>送主情報</h4></div>
                            <table class="sh041-body-order-tbl-person" >
                                <tr>
                                    <th class="required">
                                        <!-- 会社名 -->
                                        {{$t("sh030.labels.okurikaisyame")}}
                                    </th>
                                    <td>
                                        <div class="sh041-div-csmNm1">
                                            <input type="hidden" v-model="tdk.csmNo">
                                            <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                    v-model="tdk.csmNm1" size="50"
                                                    maxlength="30" class="sh041-inp-csmNm1"/>
                                        </div>
                                        <!-- 届先を検索-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="searchOkuriNushiList(index)">{{$t("sh030.labels.okuriAddressee")}}</button>
                                        <!-- 注文者情報を反映-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setKokyakuInfo(index)">{{$t("sh041.buttons.setKokyaku")}}</button>
                                        <br />
                                        <span v-html="descriptionInfo[3]"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 会社名カナ -->
                                    <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.kaisyamekana")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.okurikaisyamekana")}}</th>
                                    <td>
                                        <div class="sh041-form-column">
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                class="sh041-inp-csmKana1"
                                                v-model="tdk.csmKana1" size="50"
                                                maxlength="30" />
                                            <br/>
                                        </div>
                                        <span v-html="descriptionInfo[4]"></span>
                                    </td>
                                </tr>
                                <!-- 部署名 -->
                                <tr>
                                    <th class="optional">{{$t("sh030.labels.bushoName")}}</th>
                                    <td>
                                        <input :id="'csmNm2_'+index" type="text" :name="'csmNm2_'+index" size="50" 
                                            class="sh041-inp-csmNm2"
                                            v-model="tdk.csmNm2" maxlength="30"/><br/>
                                        <span v-html="descriptionInfo[41]"></span>
                                    </td>
                                </tr>
                                <!-- 担当者名 -->
                                <tr>
                                    <th class="optional">{{$t("sh030.labels.tantoshame")}}</th>
                                    <td>
                                        <input :id="'csmNm3_'+index" type="text" :name="'csmNm3_'+index" size="50" 
                                            class="sh041-inp-csmNm3"
                                            v-model="tdk.csmNm3" maxLength="30"/><br/>
                                        <span v-html="descriptionInfo[42]"></span>
                                    </td>
                                </tr>
                                <!-- 表示敬称 -->
                                <tr>
                                    <th class="required">
                                        <!-- 表示敬称 -->
                                        {{$t("sh030.labels.hyoujiKeisyo")}}
                                    </th>
                                    <td>
                                        <select v-model="tdk.csmTitle" :id="'csmTitle_'+index" class="sh041-sel-csmTitle">
                                            <option v-for="ken in dataInit.okuriHyoujiKeisyoList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmTitle">{{ken.VALUE}}</option>
                                        </select>
                                        <br>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 郵便番号 -->
                                        {{$t("common.labels.postalCode")}}
                                    </th>
                                    <td ontouchstart="">
                                        <input-check type="text" :id="'csmZip_'+index" :name="'csmZip_'+index" 
                                            class="zip sh041-inp-csmZip"
                                            v-model="tdk.csmZip" size="13" maxlength="8" />
                                        <!-- 住所自動入力 -->
                                        <button  @click="setAddr(index)"> {{$t("common.labels.addressSearch")}}</button>
                                        <div v-html="descriptionInfo[19]"></div>
                                    </td>
                                </tr>
                                <!-- 都道府県 -->
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <tr>
                                        <th class="required">
                                            <!-- 都道府県 -->
                                            {{$t("sh030.labels.prefectures")}}
                                        </th>
                                        <td>
                                            <select v-model="tdk.csmKen" :id="'csmKen_'+index" class="sh041-sel-csmKen">
                                                <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmKen">{{ken.VALUE}}</option>
                                            </select>
                                            <br>
                                            <div v-html="descriptionInfo[20]"></div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <input type="hidden" v-model="tdk.csmKen" />
                                </template>
                                <tr>
                                    <!-- 住所（市区郡町村） -->
                                    <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                                    <td>
                                        <input-check :id="'csmAddr1_'+index" type="text" :name="'csmAddr1_'+index" size="50"
                                            class="sh041-inp-csmAddr1"
                                            v-model="tdk.csmAddr1" maxlength="30"/>
                                        <br/>
                                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                                            <div v-html="descriptionInfo[21]"></div>
                                        </template>
                                        <template v-else>
                                            <div v-html="descriptionInfo[22]"></div>
                                        </template>
                                    </td>
                                </tr>
                                <!-- 住所（番地以下） -->
                                <tr v-if="dataInit.addr2Flg == 1">
                                    <th class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                                    <td>
                                        <input :id="'csmAddr2_'+index" type="text" :name="'csmAddr2_'+index" size="50" 
                                            class="sh041-inp-csmAddr2"
                                            v-model="tdk.csmAddr2" maxlength="30"/><br/>
                                        <div v-html="descriptionInfo[23]"></div>
                                    </td>
                                </tr>
                                <!-- 住所（マンション名・会社名等） -->
                                <tr v-if="dataInit.addr3Flg == 1">
                                    <th class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                                    <td>
                                        <input :id="'csmAddr3_'+index" type="text" :name="'csmAddr3_'+index" size="50" 
                                            class="sh041-inp-csmAddr3"
                                            v-model="tdk.csmAddr3" maxLength="30"/><br/>
                                        <div v-html="descriptionInfo[24]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 電話番号※ -->
                                        {{$t("sh030.labels.phoneNumber※")}}
                                    </th>
                                    <td>
                                        <input-check type="text" :id="'csmTel_'+index" :name="'csmTel_'+index" 
                                            class="sh041-inp-csmTel"
                                            v-model="tdk.csmTel" size="20" maxlength="14" />
                                        <br>
                                        <div v-html="descriptionInfo[25]"></div>
                                    </td>
                                </tr>
                            </table>
                            <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                            <p  class="mb64 input-p-desc-css">
                                <span v-html="descriptionInfo[31]"></span>
                            </p>
                        </div>
                        <br>
                        <!--商品情報-->
                        <div class="label divPrice" :aria-label="$t('common.labels.unitPrice')">
                            <!-- 商品一覧 ここから  -->
                            <div v-if="tdk.itemList.length > 0" class="itemTable" id="cart">
                                <div class="itemHeader dt-row">
                                    <div class="label divNo">
                                        <!--No-->
                                        <label class="no">{{$t('common.labels.no')}}</label>
                                    </div>
                                    <div class="label divItemNm ">
                                        <!-- 商品名 -->
                                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                                    </div>
                                    <div class="label divQty " style="width:10%">
                                        <!-- 数量 -->
                                        <label class="quantity ">{{$t('common.labels.quantity')}}</label>
                                    </div>
                                    <div class="label divTax ">
                                        <!--のし-->
                                        <label class="quantity" style="width:13%">{{$t('sh041.labels.noshi')}}</label>
                                    </div>
                                    <div class="label productZaikoConf " v-if="tdk.displayHanbaiSuuFlg != 0" style="width:20%">
                                        <!-- 商品在庫を見る -->
                                    </div>
                                </div>
                                <div class="itemBody">
                                    <div v-for="(product, pindex) in tdk.itemList" :key="pindex" class="itemList dt-row">
                                        <!--No -->
                                        <div class="label divNo" :aria-label="$t('common.labels.no')">
                                            {{pindex + 1}}
                                        </div>
                                        <!--商品名 -->
                                        <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                                            {{common.stringNvl(product.itemNm,'')}}
                                            <div class="divNoshiInfo" v-if="product.qtySelected > 0">{{common.stringNvl(product.noshiInfo,'')}}</div>
                                        </div>
                                        <!--数量 -->
                                        <div class="label divQty" :aria-label="$t('common.labels.quantity')" style="width:10%">
                                            <select class="sh041-sel-qty" v-model="product.qtySelected" :name="'qty_'+index + '_' + pindex" :id="'qty_'+index + '_' + pindex">
                                                <option v-for="n in product.qty+1" v-bind:key="n-1">{{n-1}}</option>
                                            </select>
                                            個
                                        </div>
                                        <!--のし--><!-- カート分割の場合、お届け希望日廃止 -->
                                        <div v-if="dataInit.cartSplitUseFlg != 1" class="label divNoshi" :aria-label="$t('sh041.labels.furiwakeQty')" style="width:13%">
                                            <input v-if="product.noshiNgKbn == '0' " type="button" 
                                                class="sh041-inp-qty"
                                                :disabled =" product.qtySelected == 0"
                                                @click="doSetShiNo(tdk.tdkSeq,product.itemCd,product.qtySelected,product.itemNm)" 
                                                :value="$t('common.buttons.changeNoshi')">
                                        </div>
                                        
                                        <div class="label productZaikoConf " v-if="tdk.displayHanbaiSuuFlg != 0" style="width:20%">
                                            <!-- 商品在庫を見る -->
                                            <span v-if="product.displayFlg === 1">
                                                    <a href="#" @click.prevent="showModal(product.itemCd,product.itemNm)" >{{$t('common.labels.productZaikoConf')}}</a>
                                                    <ModalComponent
                                                    v-if="isModalVisible"
                                                    :show="isModalVisible"
                                                    :tableData="tableData"
                                                    :selectedShouhin="selectedShouhin"
                                                    :selectedShouhinLst="selectedShouhinLst"
                                                    :note="note"
                                                    @close="isModalVisible = false"/>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 商品一覧 ここまで  -->
                        </div>
                        
                        <!-- お届け希望日 --><!-- カート分割の場合、お届け希望日廃止 -->
                        <table v-if="dataInit.cartSplitUseFlg != 1" class="sh041-body-order-tbl-person sh041-body-order-tbl-mb32" id="hide_table_haiso">
                            <tr :id="'tdkYmdScroll_'+index" >
                                <!-- お届け希望日 -->
                                <th class="">{{$t("sh060.labels.deliveryDates")}}</th>
                                <td bgcolor="#FFFFFF" height="120" class="td-res-height">
                                    <!-- 指定なし -->
                                    <input class="sh041-inp-radioGroup1" :id="'radioGroup1'+index" type="radio"  :name="'radioGroup1'+index" :value="'1'" v-model="tdk.radioGroup1" @click="hopeDayRadio(1,index)"/>
                                    <label class="sh041-lbl-radioGroup1" :for="'radioGroup1'+index">：{{$t("sh060.labels.unspecified")}}</label>
                                    <span v-if=" tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 1 && tdk.shukkaYoteibi">出荷予定日：{{tdk.shukkaYoteibi}}</span>
                                    <br><span  v-if="tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 1 && tdk.messages && tdk.messages.length" class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</span>
                                    <div v-if="tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 1 && tdk.messages && tdk.messages.length" class="error-message-warn">
                                        <span v-for="error in tdk.messages" :key="error">・{{ error }}<br></span>
                                    </div>
                                    <!-- 指定あり(1回のみ) -->
                                    <input class="sh041-inp-radioGroup2" :id="'radioGroup2'+index" type="radio" :name="'radioGroup1'+index" :value="'2'" v-model="tdk.radioGroup1" @click="hopeDayRadio(2,index)"/>
                                    <label class="sh041-lbl-radioGroup2" :for="'radioGroup2'+index">：{{$t("sh060.labels.designated")}}</label>
                                    <span v-if="tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 2 && tdk.shukkaYoteibi">出荷予定日：{{tdk.shukkaYoteibi}}</span>
                                    <br>
                                    <select class="sh041-sel-hopeDay"  name="hopeDay" id="hopeDay" v-model="tdk.hopeDay" v-if="tdk.radioGroup1 == '2'" @change="hopeDayc(index)">
                                        <option v-for="day in tdk.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                                    </select>
                                    <select class="sh041-sel-hopeDay" name="hopeDay" id="hopeDay"  v-model="tdk.hopeDay" v-else disabled @change="hopeDayc(index)">
                                        <option v-for="day in tdk.tdkYmdList" :value="day.KEY" :key="day.KEY" >{{day.VALUE}}</option>
                                    </select>
                                    <br><span  v-if="tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 2 && tdk.messages && tdk.messages.length" class="error-message-warn">{{$t("warning.labels.zaikoCheck")}}</span>
                                    <div v-if="tdk.displayHanbaiSuuFlg != 0 && tdk.radioGroup1 == 2 && tdk.messages && tdk.messages.length" class="error-message-warn">
                                        <span v-for="error in tdk.messages" :key="error">・{{ error }}<br></span>
                                    </div>

                                    <!-- 自動発注利用する and 決済方法がクレジット、掛払、代引き、全額ポイントのときのみ -->
                                    <template v-if="dataInit.autoHatchuOpt == 1 && ['1', '2', '6', '993'].includes(dataInit.reqModel.kessaiCd)">
                                        <!-- 指定あり(複数回) ※2ヶ月先までカレンダーから日付を指定して発注が可能です。 -->
                                        <input class="sh041-inp-radio3" id="radio3" type="radio" name="radioGroup1" value="3" v-model="tdk.radioGroup1" @click="hopeDayRadio(3,index)"/>
                                        <label class="sh041-lbl-radio3" for="radio3">：{{$t("sh030.labels.autoHatchu")}}</label>
                                        <br>
                                        <div v-if="tdk.radioGroup1 == '3'">
                                            
                                            <div v-for="(tdkMonth, tmIndex) in tdkMonths" :key="'tm_' + tmIndex" class="sh041-div-tdkMonth" style="margin: 0 -15px -15px 0 !important;">
                                                <div class="dt-col">
                                                    <div>{{tdkMonth.monthNm}}</div>
                                                    <div class="dt-table">
                                                        <div class="dt-row">
                                                            <div class="dt-cell" style="background: #FFD1D1">日</div>
                                                            <div class="dt-cell">月</div>
                                                            <div class="dt-cell">火</div>
                                                            <div class="dt-cell">水</div>
                                                            <div class="dt-cell">木</div>
                                                            <div class="dt-cell">金</div>
                                                            <div class="dt-cell" style="background:#CCF9FF">土</div>
                                                        </div>
                                                        
                                                        <div class="dt-row" v-for="(week, wIndex) in tdkMonth.weeks" :key="'w_' + wIndex">
                                                            <div class="dt-cell" v-for="(day, dIndex) in week" :key="dIndex" 
                                                                :style="(day.youbi == 0 || day.isHoliday) ? 'background: #FFD1D1; color:#990000;' : (day.youbi == 6 ? 'background:#CCF9FF; color:#0000FF;' : (day.val ? '' : 'background: #DEDEDE;'))">
                                                                <span>{{(day && day.val) ? day.text : ''}}</span>
                                                                <input class="ml-1" v-if="day && day.val && day.canSelect" type="checkbox" :id="'day_' + day.val" name="hopeDays" :value="day.val" v-model="reqModel.hopeDayList">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br>
                                    </template>

                                    <span v-html="descriptionInfo[32]"></span>
                                </td>
                            </tr>
                            
                            <tr v-bind:id="dataInit.tdkkibouFlg == 1 ? '' : 'tdkYmdScroll'" v-if="dataInit.tdkTimeFlg == 1">
                                <th>
                                    <!-- お届け希望時間 -->
                                    {{$t("sh060.labels.desiredDeliveryTime")}}
                                </th>
                                <td>
                                    <select class="sh041-sel-hopeTime" v-model="tdk.hopeTime">
                                        <option v-for="hopeTime in dataInit.hopeTimeList" :key="hopeTime.KEY" :value="hopeTime.KEY" >{{hopeTime.VALUE}}</option>
                                    </select>
                                    <br>
                                    <span v-html="descriptionInfo[33]"></span>
                                </td>
                            </tr>

                            <tr :id="'tdkGiftScroll_'+index" v-if="dataInit.giftFlg == 1 && tdk.tdkSeq == 0 && false">
                                <th>
                                    <!-- ギフト設定 -->
                                    {{$t("sh030.labels.giftSetting")}}
                                </th>
                                <td>
                                    <template v-if="dataInit.siteFlg != 1">
                                        <select class="sh041-sel-giftCd" name="giftCd" id="giftCd" v-model="tdk.giftCd">
                                            <option v-for="gift in dataInit.giftList" :key="gift.KEY" :value="gift.KEY">{{gift.VALUE}}</option>
                                        </select>
                                    </template>
                                    <template v-else>
                                        <!-- BtoBの場合 -->
                                        <div class="giftKbn" v-for="gift in dataInit.giftList" :key="gift.KEY">
                                            <input class="sh041-inp-giftKbnInput" type="radio" name="giftCd" :value="gift.KEY" v-model="tdk.giftCd" :id="'giftKbn_'+gift.KEY">
                                            <label class="sh041-lbl-giftKbnInput" :for="'giftKbn_'+gift.KEY">{{gift.VALUE}}</label>
                                        </div>
                                    </template>
                                    <br>
                                    <span v-html="descriptionInfo[34]"></span>
                                </td>
                            </tr>
                            <tr v-bind:id="dataInit.giftFlg == 1 ? '':'tdkGiftScroll'" v-if="dataInit.nosiFlg == 1 && tdk.tdkSeq == 0 && false">
                                <th>
                                    <!-- のし・包装紙 -->
                                    {{$t("sh060.labels.wrappingPaper")}}
                                </th>
                                <td>
                                    <!-- のし -->
                                    {{$t("sh030.labels.works")}}&nbsp;
                                    <select class="sh041-sel-sagyoKanriKomokuCd" :id="'sagyoKanriKomokuCd_'+index" v-model="tdk.sagyoKanriKomokuCd">
                                        <option value=""></option>
                                        <option v-for="noshi in dataInit.noshiList" :key="noshi.KEY" :value="noshi.KEY">{{noshi.VALUE}}</option>
                                    </select>
                                    <div v-html="descriptionInfo[28]"></div>
                                    <!-- 包装紙 -->
                                    {{$t("sh030.labels.wrappingPaper")}}&nbsp;
                                    <select class="sh041-sel-sagyoKanriKomokuCd2" :id="'sagyoKanriKomokuCd2_'+index" v-model="tdk.sagyoKanriKomokuCd2">
                                        <option value=""></option>
                                        <option v-for="housoushi in dataInit.housoushiList" :key="housoushi.KEY" :value="housoushi.KEY">{{housoushi.VALUE}}</option>
                                    </select>
                                    <br>
                                    <span v-html="descriptionInfo[27]"></span>
                                    <br>
                                    <!-- 送り主名 -->
                                    {{$t("sh030.labels.senderName")}}１&nbsp;
                                    <input-check :id="'noshiNaire1_'+index" :name="'noshiNaire1_'+index"  
                                        class="sh041-inp-okurinushi" type="text" v-model="tdk.noshiNaire1"/>
                                    <div v-html="descriptionInfo[29]"></div>
                                    <br>
                                    <!-- 送り主名 -->
                                    {{$t("sh030.labels.senderName")}}２&nbsp;
                                    <input-check :id="'noshiNaire2_'+index" class="sh041-inp-okurinushi" type="text" v-model="tdk.noshiNaire2"/>
                                    <div v-html="descriptionInfo[30]"></div>
                                    <br>
                                    <span v-html="descriptionInfo[35]"></span>
                                </td>
                            </tr>
                            <tr :id="'bikoScroll_'+index" v-if="dataInit.bikoFlg == 1 && tdk.tdkSeq == 0 && false">
                                <th>
                                    <!-- 備考欄 -->
                                    {{$t("common.labels.remarkColumn")}}
                                </th>
                                <td>
                                    <textarea class="sh041-txt-biko" :id="'biko_'+index" :name="'biko_'+index" rows="4" cols="75" maxlength="500" v-model="tdk.biko"> </textarea>
                                    <br>
                                    <span v-html="descriptionInfo[36]"></span>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            <!-- お届け先 ここまで  -->

            <div class="btnSubmitsh041">
                <!-- 前ページに戻る -->
                <li><button class="sh041-btn-back" @click="back" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button></li>
                <!-- 次へ -->
                <li><button class="sh041-btn-next" @click="doNext" type="button">{{$t("sh041.buttons.update")}}</button></li>
            </div>
        </div>
        
        
        <span style="display:none" id="name_lbl">{{$t("sh041.labels.name")}}</span>
        <span style="display:none" id="nameKana_lbl">{{$t("sh041.labels.nameKana")}}</span>
        <span style="display:none" id="nameComp_lbl">{{$t("sh041.labels.kaisyame")}}</span>
        <span style="display:none" id="nameKanaComp_lbl">{{$t("sh041.labels.kaisyamekana")}}</span>
        <span style="display:none" id="mail_lbl">{{$t("sh041.labels.deliveryMailAddress")}}</span>
        <!-- 都道府県 -->
        <span style="display:none" id="prefectures_lbl">{{$t('sh041.labels.prefectures')}}</span>
        <!-- 郵便番号 -->
        <span style="display:none" id="postalCode_lbl">{{$t('sh041.labels.postalCode')}}</span>
        <!-- 電話番号 -->
        <span style="display:none" id="phoneNumber_lbl">{{$t('common.labels.phoneNumber')}}</span>
        <!-- 営業所コード -->
        <span style="display:none" id="yaOfficeCd_lbl">{{$t('sh041.labels.yaOfficeCd')}}</span>
        <alert-confirm
            v-if="isZipMsgAlert"
            :msgConfirm="zipMsg"
            :isButtonCancel="false"
            :okAction="isZipRequiredMsgClose"
            @closedModal="isZipMsgAlert=false"
        ></alert-confirm>

        <alert-confirm
            v-if="isItemCntZeroMsgAlert"
            :msgConfirm="itemCntZeroMsg"
            :isButtonCancel="true"
            :okAction="submit"
            @closedModal="isItemCntZeroMsgAlert=false"
            size="md"
        ></alert-confirm>

        <b-modal v-model="isUpdCartQtyAlert"
            size="lg"
            :title="$t('sh041.labels.qtyConfirm')" 
            no-close-on-backdrop
            centered>
            <div class="sh041-alert-message" >
                <li class="text-danger">{{$t('sh041.messages.updateCartQty')}}</li>
            </div>
            <div class="updCartQtyAlert col-12 mb-1">
                <div class="itemHeader">
                    <div class="label divNo">
                        <!--No-->
                        <label class="no">{{$t('common.labels.no')}}</label>
                    </div>
                    <div class="label divItemNm">
                        <!-- 商品名 -->
                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                    </div>
                    <div class="label divQty">
                        <!-- カート数量 -->
                        <label class="quantity">{{$t('sh041.labels.cartQuantity')}}</label>
                    </div>
                    <div class="label divTax">
                        <!--振分済数-->
                        <label class="quantity">{{$t('sh041.labels.furiwakeQty')}}</label>
                    </div>
                </div>
                <div v-for="(product, index) in dataInit.cartInfoList" :key="index" class="itemList">
                    <!--No -->
                    <div class="label divNo" :aria-label="$t('common.labels.no')">
                        {{index + 1}}
                    </div>
                    <!--商品名 -->
                    <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                        <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.M_ITEM_CD}}">
                            {{common.stringNvl(product.WEB_ITEM_NM,'')}}
                        </router-link>
                        <div v-for="(item, idx) in dataInit.optionList" :key="idx">
                            <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                        </div>
                    </div>
                    <!--カート数量 -->
                    <div class="label divQty" :aria-label="$t('common.labels.quantity')">
                        <span>{{product.QTY}}</span>
                    </div>
                    <!--振分済数-->
                    <div  class="label divQty" :aria-label="$t('sh041.labels.furiwakeQty')">
                        <span v-if = "product.BINSYU_KBN == '90' " >{{$t('sh041.labels.shopReceipt')}}</span>
                        <span v-else> {{furiwakeQty(product.M_ITEM_CD,product.SEQ)}}</span>
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="sh041-footer w-100">
                <div class="sh041-modal-footer text-center">
                    <!-- 更新する -->
                    <li><input class="sh041-model-btn-upd" @click="updCartQty()" :value="$t('common.buttons.update')" type="button"></li>
                    <!-- キャンセル -->
                    <li><input class="sh041-model-btn-cencel" @click="isUpdCartQtyAlert=false;" :value="$t('common.buttons.cancel')" type="button"></li>
                </div>
            </div>
        </b-modal>

        <alert-confirm
            v-if="isItemCntZeroOfOneTdkMsgAlert"
            :msgConfirm="itemCntZeroOfOneTdkMsg"
            :isButtonCancel="false"
            @closedModal="isItemCntZeroOfOneTdkMsgAlert=false"
            size="md"
        ></alert-confirm>
    
        <alert-confirm
            v-if="isErrorAlert"
            :msgConfirm="errorMsg"
            :isButtonCancel="false"
            @closedModal="isErrorAlert=false"
            size="md"
        ></alert-confirm>

        <CC212InputPostal v-if="isCCInputPostalShow" @modal-close="isCCInputPostalShow = false" :propTdkZip1="cc212Prop.propTdkZip1" 
            :propTdkZip2="cc212Prop.propTdkZip2" :propIdx="cc212Prop.propIdx" @set-addr-value="setAddrValue" />
        <CC211SearchOkuriNushiList v-if="isSearchOkurinushiList" @modal-close="isSearchOkurinushiList = false" 
            :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="1" @set-addr-value="setOkurinushiValueCc211" />
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import AlertConfirm from "components/AlertConfirm";
import mapInfo from "assets/js/mapInfo";
import EventBus from "assets/js/eventBus";
import SiteConstants from 'assets/const/SiteConstants.json';
import Message from 'components/MessageEcSite';
import CC212InputPostal from '../search/CC212InputPostal';
import CC211SearchOkuriNushiList from '../search/CC211SearchTdkList';
import CC215SearchDairiList from '../search/CC215SearchDairiList';
import ModalComponent from '../popup/HanbaiSuuSettingPopup.vue';

export default {
    /* 
    * Name of component
    */
    name: "SH041ShopperTdkInfoSetting",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        Loading,
        AlertConfirm,
        Message,
        InputNumber,
        CC212InputPostal,
        CC211SearchOkuriNushiList,
        CC215SearchDairiList,
        ModalComponent
    },/* 
    * Declare variable and set default value
    */
    data() {
        return {
            totalRecord: 50,
            fromRecord: 1,
            toRecord: 10,
            pageSize: 10,
            pageNo: 1,
            goto: 0,
            common: common,
            dataInit:{
                descriptionInfo:{}
            },
            radioGroup:"",
            siteFlg:0,
            reqModel:{
                teikiFlg : 0,
                hopeDayList: []
            },
            isModalVisible: false,
            tableData: [],
            selectedShouhinLst : [],
            selectedShouhin: '',
            note: '',
            mapInfoResp:{},
            mapInfoChangeTdkFlag:false,
            isUpdCartQtyAlert:false,
            isZipMsgAlert:false,
            isItemCntZeroMsgAlert:false,
            isItemCntZeroOfOneTdkMsgAlert:false,
            isErrorAlert:false,
            zipMsg:"",
            itemCntZeroMsg:"",
            itemCntZeroOfOneTdkMsg:"",
            SiteConstants: SiteConstants,
            SH041_PART:'sh041',
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            isCCInputPostalShow:false,
            
            isSearchOkurinushiList:false,
            isSearchOkurinushiCompList:false,
            cc212Prop:{},
            cc211Prop:{},
            tdkIndex:0,
            getGiftCd:null,
            disableOption:null,
            descriptionInfo:[],
            NO_CART_ERR : "001",
            site: "",
            tdkInfoFlg : false,
            paySkipFlg : false,
            confirmFlg : false,
            completeFlg : false,
            showTeikiFlg : false,
            showBetuOrder : false,
            isLoading: false,
            getImageOpenNewWindow: common.getImages('openNewWindow'),
            queryData : null,
            sh060 : {
                orderConfirmFlg : null
            },
            tdkMonths: [],
            firstTdkYmd: '',
            disableMon: false,
            disableTue: false,
            holidays: []
        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        var tranferdata = {};
        if (sessionStorage['sh041TranferData']) {
          tranferdata = JSON.parse(sessionStorage['sh041TranferData']);
          sessionStorage.removeItem('sh041TranferData');
        }

        if (_this.ptInitData) {
            _this.isLoading = true;
            try {
                if (_this.ptInitData.status != 'OK') {
                    if(_this.ptInitData.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:2}});
                        return;
                    }
                }

                _this.dataInit = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);
                
                if(_this.reqModel.tdkFlg == '3') {
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1') {
                    _this.reqModel.radioGroup ='1';
                }

                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }

                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0) {
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkNm3 = _this.reqModel.kokyakuNm3;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                    _this.reqModel.tdkKana3 = _this.reqModel.kokyakuKana3;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                if (_this.dataInit.radioGroup1 == null || _this.dataInit.radioGroup1 == '1') {
                    _this.disableOption = true;
                }
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if (_this.ptInitData.siteFlg!=1) _this.siteFlg = 0;

                if (_this.reqModel.radioGroup1 == undefined) _this.reqModel.radioGroup1 = '1';
                if (_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';


                _this.reqModel.resultTeikiItemList = _this.ptInitData.resultTeikiItemList;
                if (_this.reqModel.resultTeikiItemList != null && _this.reqModel.resultTeikiItemList != '') {
                    _this.showTeikiFlg = true;
                    _this.reqModel.teikiFlg = 1;
                } else {
                    _this.showTeikiFlg = false;
                    _this.reqModel.teikiFlg = 0;
                }

                if (tranferdata && tranferdata.reqModel) {
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.reqModel.tdkInfoList.length;i++){
                        var tdkInfo = tranferdata.reqModel.tdkInfoList[i];
                        for(var j=0;j<tdkInfo.itemList.length;j++){
                            var itemTdk = tdkInfo.itemList[j];
                            itemTdk.noshiInfo = _this.reqModel.tdkInfoList[i].itemList[j].noshiInfo;
                        }
                    }
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if (tranferdata && tranferdata.dataInit) {
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }

                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.scrollId == '3' && _this.dataInit.kokyakuNo != 999999999) {
                    var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkSeq]
                    tdkInfo.okuriNushiCheckBox = 1;
                }
                _this.filterTdkDateByItem();
                _this.initTdkMonths();

                if (sessionStorage['hopeDayList']) {
                    _this.reqModel.radioGroup1 = '3';
                    _this.reqModel.hopeDayList = JSON.parse(sessionStorage['hopeDayList']);
                }

                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    console.log('scroll :scrollId='+_this.scrollId);
                    _this.scroll();
                });

                _this.$forceUpdate();
            } catch (error) {
                common.errorAPI(error);
            } finally {
                _this.isLoading = false;
            }
        } else {
            _this.isLoading = true;
            axios.get(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_INIT).then(function(response) {
                if (response.data.status != 'OK') {
                    if(response.data.respCode == _this.NO_CART_ERR) {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 2}});
                        return;
                    }
                }

                _this.dataInit = response.data;
                _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);
                
                if(_this.reqModel.tdkFlg == '3'){
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1'){
                    _this.reqModel.radioGroup ='1';
                }
                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }
                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0){
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkNm3 = _this.reqModel.kokyakuNm3;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                    _this.reqModel.tdkKana3 = _this.reqModel.kokyakuKana3;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                if(_this.dataInit.radioGroup1 == null || _this.dataInit.radioGroup1 == '1'){
                    _this.disableOption = true;
                }
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if(response.data.siteFlg!=1) _this.siteFlg = 0;

                if(_this.reqModel.radioGroup1 == undefined) _this.reqModel.radioGroup1 = '1';
                if(_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';


                if(tranferdata && tranferdata.reqModel){
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.reqModel.tdkInfoList.length;i++){
                        var tdkInfo = tranferdata.reqModel.tdkInfoList[i];
                        for(var j=0;j<tdkInfo.itemList.length;j++){
                            var itemTdk = tdkInfo.itemList[j];
                            itemTdk.noshiInfo = _this.reqModel.tdkInfoList[i].itemList[j].noshiInfo;
                        }
                    }
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if(tranferdata && tranferdata.dataInit){
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }
                _this.hopeDayc(-1);

                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.scrollId == '3' && _this.dataInit.kokyakuNo != 999999999) {
                    var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkSeq]
                    tdkInfo.okuriNushiCheckBox = 1;
                }
                _this.filterTdkDateByItem();
                _this.initTdkMonths();

                if(sessionStorage['hopeDayList']) {
                    _this.reqModel.radioGroup1 = '3';
                    _this.reqModel.hopeDayList = JSON.parse(sessionStorage['hopeDayList']);
                }

                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    console.log('scroll :scrollId='+_this.scrollId);
                    _this.scroll();
                });

                _this.$forceUpdate();
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });
        }
        
        EventBus.$on("closed", function() {
            _this.isZipMsgAlert = false;
            _this.isUpdCartQtyAlert = false;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;
            _this.isSearchOkurinushiList = false;
            _this.isSearchOkurinushiCompList = false;
            _this.isErrorAlert = false;
        });
        EventBus.$on('closed2', function(msgConfirm){
            if(msgConfirm==_this.$t("sh041.labels.zipCodeDoesNotExist")) {
                _this.isZipRequiredMsgClose();
            }
        });

    },
    /* 
    * Methods
    */
    methods: {
        furiwakeQty: function(sItemCd,seqNo) {
            var _this = this;
            
            var furiwakeQty = 0;
            if(_this.reqModel.tdkInfoList == null || _this.reqModel.tdkInfoList == undefined) return furiwakeQty;

            for (var i = 0; i < _this.reqModel.tdkInfoList.length; i++) {
                var tdkInfo = _this.reqModel.tdkInfoList[i];
                for (var j = 0; j < tdkInfo.itemList.length; j++) {
                    var itemTdk = tdkInfo.itemList[j];
                    if (itemTdk.itemCd == sItemCd && itemTdk.orderLineNo == seqNo) {
                        furiwakeQty = furiwakeQty + parseInt(common.stringNvl(itemTdk.qtySelected, '0'));
                    }
                }
            }
            return furiwakeQty;
        },
        /* 
        * [次へ]ボタンを押下
        */
        doNext: function() {
            var _this = this;
            _this.reqModel.tdkInfoList = _this.reqModel.tdkInfoList;

            // 販売数設定商品のとき、お届け希望日必須チェック
            for (var i = 0; i < _this.reqModel.tdkInfoList.length; i++) {
                var tdkInfo = _this.reqModel.tdkInfoList[i];
                if(tdkInfo.displayHanbaiSuuFlg && tdkInfo.displayHanbaiSuuFlg != 0) {
                    var itemList = tdkInfo.itemList;
                    for (var j = 0; j < itemList.length; j++) {
                        var itemTdk = itemList[j];
                        if (itemTdk.displayFlg == 1 && common.stringNvl(itemTdk.qtySelected, '0') > 0) {
                            var tdkYmd = tdkInfo.hopeDay;
                            // カート分割の場合、チェック仕様廃止
                            if(_this.dataInit.cartSplitUseFlg != 1){//カート分割しない場合
                                // お届け希望日が指定されてない場合
                                if (!tdkYmd){
                                    _this.errorMsg = _this.setErrorMsg(tdkInfo, i+1, 'hopeDay');
                                    _this.isErrorAlert = true;
                                    return;
                                }
                            }
                        }
                    }
                }
            }
            
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + "/doCheckHanbaiSuu", _this.reqModel).then(function(response) {
                if(response.data.status=="NG"){
                    _this.reqModel.tdkInfoList = response.data.tdkInfoList;
                    return;
                } else {
                    // お届け先情報の商品数量チェック（商品合計が0の場合、エラー）
                    for (var i = 0; i < _this.reqModel.tdkInfoList.length; i++) {
                        var tdkInfo = _this.reqModel.tdkInfoList[i];
                        var tdkItemQty = 0;
                        for (var j = 0; j < tdkInfo.itemList.length; j++) {
                            var itemTdk = tdkInfo.itemList[j];
                            tdkItemQty = tdkItemQty + parseInt(common.stringNvl(itemTdk.qtySelected, '0'));
                        }
                        if(tdkItemQty == 0){
                            _this.itemCntZeroOfOneTdkMsg = _this.setErrorMsg(tdkInfo, i+1, 'qty');
                            _this.isItemCntZeroOfOneTdkMsgAlert = true;
                            return;
                        }
                    }
                
                    //振分数量チェック
                    if(_this.dataInit.cartInfoList && _this.dataInit.cartInfoList.length>0){
                        for(var i=0;i<_this.dataInit.cartInfoList.length;i++){
                            var cartInfo = _this.dataInit.cartInfoList[i];
                            if(_this.furiwakeQty(cartInfo.M_ITEM_CD,cartInfo.SEQ) != cartInfo.QTY && cartInfo.BINSYU_KBN != '90'){
                                _this.isUpdCartQtyAlert= true;
                                return;
                            }
                        }
                    }
                
                    _this.submit();
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },

        /* 
        * エラーメッセージの編集処理
        */
        setErrorMsg: function(tdkInfo, index, type) {
            var _this = this;
            var errorMsg;
            if(tdkInfo.tdkFlg === '1') {
                errorMsg = '届先' + index + '件目（注文者様宛）' +'の';
            } else {
                errorMsg = '届先' + index + '件目(' + tdkInfo.tdkNm1 + ' ' + tdkInfo.tdkNm2 + ' ' + tdkInfo.tdkNm3 + tdkInfo.tdkTitle +'宛）' +'の';
            }
            if(type === 'hopeDay') {
                errorMsg = errorMsg + _this.$i18n.t('sh030.messages.haitatsuKiboubiSetting');
            }
            if(type === 'qty') {
                errorMsg = errorMsg + _this.$t("sh041.messages.tdkItemZeroError");
            }
            return errorMsg;
        },

        /* 
        * カート数量更新
        */
        updCartQty: function() {
            var _this = this;

            this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH041_PART);

            //振分数量で、カート数量を更新する
            for(var i=0;i<_this.dataInit.cartInfoList.length;i++){
                var cartInfo = _this.dataInit.cartInfoList[i];
                cartInfo.QTY = _this.furiwakeQty(cartInfo.M_ITEM_CD,cartInfo.SEQ);
            }
            var reqModel = {
                cartInfoList: _this.dataInit.cartInfoList
            };
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_AJAX, reqModel).then(function(response) {
                _this.$emit("event-loading", false);
                if(response.data.status=="OK"){
					_this.isUpdCartQtyAlert = false;
                    _this.submit();
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH050_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },

        submit:function(){
            var _this = this;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;

            _this.reqModel.siteFlg = _this.siteFlg;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH041_PART);
            _this.reqModel.itemTdkList = _this.dataInit.itemTdkList;

            if (_this.dataInit.tdkCount > 1 && _this.reqModel.tdkNo != 0) {
                _this.reqModel.radioGroup = 6;
            }

            
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status=="OK"){
                    if(_this.reqModel.radioGroup1 == 3) {
                        sessionStorage.setItem('hopeDayList', JSON.stringify(_this.reqModel.hopeDayList.sort()));
                    } else {
                        sessionStorage.removeItem('hopeDayList');
                        sessionStorage.removeItem('totalPointKin');
                    }
                    // ゲスト購入の場合
                    if (_this.dataInit.kokyakuNo == 999999999) {
                        if (_this.dataInit.paySkipFlg == 1 || _this.sh060.orderConfirmFlg == 1 ) {
                            // 支払方法割愛オプション（50502）有のときor注文確認画面から遷移した場合は、注文内容確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22, actionId : 1}});
                        } else {
                            // 支払方法確認画面へ
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 21}});
                        }
                    } else {
                        // 会員ログイン時は、注文内容確認画面へ
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
                    }
                    _this.$emit("event-loading", false);
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH050_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        gotobak:function(){
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
        },
        // 配送希望日選択時 data:1 指定なし  data2 指定あり
		hopeDayRadio:function(data,tdkIdx){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIdx];
            _this.reqModel.tdkInfoList[tdkIdx].shukkaYoteibi = "";
            // 指定なしの場合
            if (data != 2) {
                // 指定日をリセット
                tdkInfo.hopeDay = "";
                // 定期商品リストを非表示
                _this.showTeikiFlg = false;
                // 定期フラグをリセット
                _this.reqModel.teikiFlg = 0;
                _this.reqModel.index = tdkIdx;
                axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + "/getShipYoteiCheck", _this.reqModel).then(function(ajaxRespone) {
                        _this.reqModel.tdkInfoList[tdkIdx].shukkaYoteibi = ajaxRespone.data.shukkaYoteibi;
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                    common.scrollTop();
                });
            }
            _this.$forceUpdate();
        },

        initTdkMonths() {
            var _this = this;
            _this.tdkMonths = [];

            // 便種「宅急便（冷凍ドライ）」の商品を含む場合は、月曜日が指定できないようにする
            // もし、リードタイムが1日より長い場合は、火曜も不可とします
            //for(let itemTdk of this.dataInit.itemTdkList) {
            //    if(itemTdk['BINSYU_KBN'] == 121) {
            //        _this.disableMon = true;
            //        if(itemTdk['SYUKKA_LEAD'] > 0) {
            //            _this.disableTue = true;
            //        }
            //        break;
            //    }
            //}

            //_this.firstTdkYmd = _this.dataInit.tdkYmdList[1]['KEY'];
            //let months = _this.getNextTwoMonths(_this.firstTdkYmd);

            //fetch('https://holidays-jp.github.io/api/v1/date.json').then(function(response) {
            //    return response.json();
            //}).then(function(holidaysObj) {
            //    let keys = Object.keys(holidaysObj);
            //    _this.holidays = keys.map(key => key.replace(/-/g, '/'));

            //}).catch(function(error) {
            //    console.error('Error:', error);
            //}).finally(function() {

            //    for (let [index, month] of months.entries()) {

            //        let weeks = _this.getWeeksInMonth(month, index);
            //        _this.tdkMonths.push({
            //            monthNm: month,
            //            weeks: weeks
            //        });
            //    }
            //});
        },

        filterTdkDateByItem() {
            for(let i = 0 ;i<this.reqModel.tdkInfoList.length;i++){
                var tdkInfo = this.reqModel.tdkInfoList[i];
                for(let j = tdkInfo.tdkYmdList.length - 1; j >= 0; j--) {
                    const tdkYmd = tdkInfo.tdkYmdList[j];
                    if(tdkYmd.KEY) {
                        const tdkDate = new Date(tdkYmd.KEY);
                        const dayOfWeek = tdkDate.getDay();
                        const daysInJapanese = ['(日)', '(月)', '(火)', '(水)', '(木)', '(金)', '(土)'];
                        tdkYmd.VALUE = tdkYmd.KEY + daysInJapanese[dayOfWeek];
                        //this.reqModel.tdkInfoList[i].tdkYmdList.splice(j, 1);
                    }
                }
            }
        },

        // 定期予定商品一覧取得
        hopeDayc:function(tdkIdx){
            var _this = this;
            var day = this.reqModel.hopeDay;
            _this.reqModel.index =  tdkIdx;
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + "/getShipYoteiCheck", _this.reqModel).then(function(ajaxRespone) {
                        _this.reqModel.tdkInfoList[tdkIdx].shukkaYoteibi = ajaxRespone.data.shukkaYoteibi;
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
            //var ajaxReqModel = {
            //        ajaxFlg:'1',
            //        hopeDay: day
            //    }
            //axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_AJAX, ajaxReqModel).then(function(ajaxRespone) {
            //    _this.reqModel.resultTeikiItemList = ajaxRespone.data.resultTeikiItemList;
            //    if (_this.reqModel.resultTeikiItemList != null && _this.reqModel.resultTeikiItemList != '') {
            //        _this.showTeikiFlg = true;
            //        _this.reqModel.teikiFlg = 1;
            //    } else {
            //        _this.showTeikiFlg = false;
            //        _this.reqModel.teikiFlg = 0;
            //    }
            //    _this.$forceUpdate();
            //}).catch(function(error) {
            //    _this.$emit("event-loading", false);
            //    common.errorAPI(error);
            //    common.scrollTop();
            //});
        },
        setAddrValue:function(data){
            var _this = this;
            var idx = data.idx;
            var tdkInfo = _this.reqModel.tdkInfoList[idx];
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd+"";
            tdkInfo.csmAddr1 = addr1;
            tdkInfo.csmKen = kenCd;
        
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        nextPage: function(){
			var _this = this;
			common.clearMessage(_this.listIdErr,"","sh041")
			_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 20}});
		},
        setAddr:function(idx){
            var _this = this;
            _this.tdkIndex = idx;
            var tdkInfo = _this.reqModel.tdkInfoList[idx];
            var zip = tdkInfo.csmZip;
            
            if(!zip) {
                _this.isZipMsgAlert = true;
                _this.zipMsg = _this.$t("sh041.labels.zipCodeIsMandatory");
				return;
			}
            var zipArr = zip.split("-");
            var zip1 = "";
            var zip2 = "";
            if (zipArr.length == 2) {
                zip1 = zipArr[0];
                zip2 = zipArr[1];
            }else{
                zip1 = zip.substr(0,3);
                zip2 = zip.substr(3);
                tdkInfo.csmZip=zip1+"-"+zip2;
            }
            var reqModel = {
                idx:idx,
                tdkZip1:zip1,
                tdkZip2:zip2
            }
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.POPUP +_this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, reqModel).then(function(response) {
                if(response.data.kenCd!=undefined) {
                    tdkInfo.csmKen = response.data.kenCd+"";
                    tdkInfo.csmAddr1 = response.data.allAddr;
                    if(response.data.allAddr!=""){
                        var allAddr = '';

                        var splAdd = response.data.allAddr.split(",");
                        allAddr = splAdd[0] != null ? splAdd[0]:'';
                        allAddr += splAdd[1] != null ? splAdd[1]:'';
                        allAddr += splAdd[2] != null ? splAdd[2]:'';
                        var addr1 = allAddr;
                        //都道府県のプルダウンを使用しない場合
                        if(_this.dataInit.kenPulldownDispFlg == 0){
                            tdkInfo.csmAddr1 = response.data.kenNm + addr1;
                        }else{
                            tdkInfo.csmAddr1 = addr1;
                        }
                    } 
                }
                if(response.data.allAddr==""){
                    _this.isZipMsgAlert = true;
                    _this.zipMsg = _this.$t("sh041.labels.zipCodeDoesNotExist");
                } else if(response.data.allAddr=="juufuku") {
                    _this.openSub(idx, zip1, zip2);
                }

                _this.$emit("event-loading", false);
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },
        openSub:function(idx, zip1, zip2){
            var _this = this;
            _this.cc212Prop = {
                propTdkZip1:zip1,
                propTdkZip2:zip2,
                propIdx:idx,
            }
            _this.isCCInputPostalShow = true;
        },
        isZipRequiredMsgClose:function(){
            var _this = this;
            _this.isZipMsgAlert = false;
        },
        
        
        back:function(){
            var _this = this;
            // 届先選択画面へ
            _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: 20}});

        },
        
        showModal(itemCd,itemNm) {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH030 + "/getShipYotei", itemCd+":"+itemNm).then(function(response) {
                if (response.data && response.data.inventoryItemModelLst) {
                    _this.tableData = response.data.inventoryItemModelLst;
                    _this.selectedShouhinLst = response.data.itemNmLst;
					var shouhin = response.data.colSizList.find(item => item['KEY'] === itemCd);
					_this.selectedShouhin = shouhin ? shouhin['VALUE'] : itemNm;
                    _this.isModalVisible = true;
                    _this.note = response.data.memo;
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        /*
        * 送主検索ボタン押下時
        */
        searchOkuriNushiList:function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchOkurinushiList=true;
        },
        /*
        * 注文者情報を反映する
        */
        setKokyakuInfo:function(tdkIndex){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIndex];
            tdkInfo.csmNo = '0';
            tdkInfo.csmNm1 = _this.reqModel.kokyakuNm1;
            tdkInfo.csmNm2 = _this.reqModel.kokyakuNm2;
            tdkInfo.csmNm3 = _this.reqModel.kokyakuNm3;
            tdkInfo.csmKana1 = _this.reqModel.kokyakuKana1;
            tdkInfo.csmKana2 = _this.reqModel.kokyakuKana2;
            tdkInfo.csmKana3 = _this.reqModel.kokyakuKana3;
            tdkInfo.csmZip = _this.reqModel.kokyakuZip;
            tdkInfo.csmKen = _this.reqModel.kokyakuKen;
            tdkInfo.csmAddr1 = _this.reqModel.kokyakuAddr1;
            tdkInfo.csmAddr2 = _this.reqModel.kokyakuAddr2;
            tdkInfo.csmAddr3 = _this.reqModel.kokyakuAddr3;
            tdkInfo.csmTel = _this.reqModel.kokyakuTel;
            //_this.reqModel.okuriHyoujiKeisyo = data.value.TDK_KEISYOU;
            _this.$forceUpdate();
        },
        /*
        * 送り主を一括反映する
        */
        setIkkatuOkuriInfo:function(tdkIndex){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIndex];
            if (common.isNullItem(tdkInfo.csmNm1) || common.isNullItem(tdkInfo.csmNm2) || common.isNullItem(tdkInfo.csmZip) || common.isNullItem(tdkInfo.csmKen) || common.isNullItem(tdkInfo.csmAddr1) || common.isNullItem(tdkInfo.csmTel)) {
                _this.isZipMsgAlert = true;
                _this.zipMsg = _this.$t("sh041.messages.okuriError");
                return;
            }

            for(let j = 0; j < _this.reqModel.tdkInfoList.length; j++) {
                const tdkinfoList = _this.reqModel.tdkInfoList[j];
                if (tdkIndex != j) {
                    tdkinfoList.csmNo = '0';
                    tdkinfoList.okuriNushiCheckBox = 1;
                    tdkinfoList.csmNm1 = tdkInfo.csmNm1;
                    tdkinfoList.csmNm2 = tdkInfo.csmNm2;
                    tdkinfoList.csmNm3 = tdkInfo.csmNm3;
                    tdkinfoList.csmKana1 = tdkInfo.csmKana1;
                    tdkinfoList.csmKana2 = tdkInfo.csmKana2;
                    tdkinfoList.csmKana3 = tdkInfo.csmKana3;
                    tdkinfoList.csmZip = tdkInfo.csmZip;
                    tdkinfoList.csmKen = tdkInfo.csmKen;
                    tdkinfoList.csmAddr1 = tdkInfo.csmAddr1;
                    tdkinfoList.csmAddr2 = tdkInfo.csmAddr2;
                    tdkinfoList.csmAddr3 = tdkInfo.csmAddr3;
                    tdkinfoList.csmTel = tdkInfo.csmTel;
                }
            }
            _this.$forceUpdate();
        },
        
        /*
        * 送主情報をセット
        */
        setOkurinushiValueCc211(data){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkIndex];
            tdkInfo.csmNo = data.value.TDK_NO;
            tdkInfo.csmNm1 = data.value.TDK_NM1;
            tdkInfo.csmNm2 = data.value.TDK_NM2;
            tdkInfo.csmNm3 = data.value.TDK_NM3;
            tdkInfo.csmKana1 = data.value.TDK_KANA1;
            tdkInfo.csmKana2 = data.value.TDK_KANA2;
            tdkInfo.csmKana3 = data.value.TDK_KANA3;
            tdkInfo.csmZip = data.value.TDK_ZIP;
            tdkInfo.csmKen = data.value.TDK_KEN;
            tdkInfo.csmAddr1 = data.value.KEN_NM + data.value.TDK_ADDR1;
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                tdkInfo.csmAddr1 = data.value.KEN_NM + data.value.TDK_ADDR1;
            }else{
                tdkInfo.csmAddr1 = data.value.TDK_ADDR1;
            }
            tdkInfo.csmAddr2 = data.value.TDK_ADDR2;
            tdkInfo.csmAddr3 = data.value.TDK_ADDR3;
            tdkInfo.csmTel = data.value.TDK_TEL1;
            tdkInfo.csmTitle = data.value.TDK_KEISYOU;
            //_this.reqModel.okuriHyoujiKeisyo = data.value.TDK_KEISYOU;
            _this.$forceUpdate();
        },
        
        /*
        * しの情報設定
        */
        doSetShiNo:function(tdkSeq,itemCd,itemQty,itemNm1){
            var tranferdata = {}; 
            tranferdata.reqModel=this.reqModel;
            tranferdata.dataInit=this.dataInit;
            
            sessionStorage['sh041TranferData'] = JSON.stringify(tranferdata);
            this.$router.push(
                { name: this.SiteConstants.PG010MAIN
                , params: {dispOnly : 0,backPageNo:28,tdkNo:tdkSeq,itemCd:itemCd,qty:itemQty,itemNm1:itemNm1,kokyakuNm1:''}
                , query: {pageNo: 26}
                }
            );
        },

        getNextTwoMonths(dateStr) {
            const parts = dateStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const date = new Date(year, month);

            const result = [];
            for (let i = 0; i < 3; i++) {
                let month = date.getMonth() + 1; 
                let year = date.getFullYear();
                result.push(`${year}/${String(month).padStart(2, '0')}`);
                date.setMonth(date.getMonth() + 1); 
            }

            return result;
        },

        getWeeksInMonth(monthStr, index) {
            const parts = monthStr.split('/');
            const year = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1;
            const firstDayOfMonth = new Date(year, month, 1);
            const lastDayOfMonth = new Date(year, month + 1, 0);

            const weeks = [];
            for (let i = 0; i < 6; i++) {
                weeks.push(new Array(7).fill(null).map(() => ({ val: null, text: null, youbi: null })));
            }

            let currentWeek = 0;
            let dayOfWeek = firstDayOfMonth.getDay();

            for (let day = 1; day <= lastDayOfMonth.getDate(); day++) {
                const dateStr = `${year}/${String(month + 1).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
                weeks[currentWeek][dayOfWeek] = {
                    val: dateStr,
                    text: day,
                    youbi: dayOfWeek,
                    isHoliday: this.holidays.includes(dateStr),
                    canSelect: ((index === 0 && new Date(dateStr) < new Date(this.firstTdkYmd)) || (this.disableMon && dayOfWeek == 1) || (this.disableTue && dayOfWeek == 2)) ? false : true
                };
                if (dayOfWeek === 6 && day !== lastDayOfMonth.getDate()) {
                    currentWeek++;
                }
                dayOfWeek = (dayOfWeek + 1) % 7;
            }

            return weeks;
        },
        /*
        * スクロール
        * 注文内容確認画面でどの「変更」を押したかによって、スクロールさせる
        */
        scroll:function(){
            var eleId;
            console.log('scroll :scrollId='+this.scrollId+' tdkSeq='+this.tdkSeq);
            switch(this.scrollId) {
                case '0':
                    // お届け先情報
                    eleId = 'tdkInfo_'+this.tdkSeq;
                    break;
                case '1':
                    // 配送希望日時
                    eleId = 'tdkYmdScroll_'+this.tdkSeq;
                    break;
                case '2':
                    // ギフト設定
                    eleId = 'tdkGiftScroll_'+this.tdkSeq;
                    break;
                case '3':
                    // 送主設定
                    eleId = 'tdkOkuriScroll_'+this.tdkSeq;
                    break;
                case '4':
                    // 備考欄
                    eleId = 'bikoScroll_'+this.tdkSeq;
                    break;
                default:
                    eleId = '';
                    break;
            }
            console.log('scroll :eleId = '+eleId);
            let element = document.getElementById(eleId);
            if (element != null){
                console.log('scroll :element  != null');
                document.getElementById(eleId).scrollIntoView();
            }
        },

    },

    created() {
        var _this = this;
        _this.scrollId ='';
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0) {
            _this.scrollId = queryData.scrollId;
            _this.tdkSeq = queryData.tdkSeq;
            _this.sh060 = queryData;
        }
    }
}
</script>
